import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when scrolled down 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-6 right-6 z-50
        h-10 px-3
        bg-zinc-900/80 backdrop-blur-sm
        border border-zinc-700
        text-zinc-400 hover:text-tiffany-500 hover:border-tiffany-500/50
        flex items-center gap-2
        transition-all duration-300 ease-out
        ${isVisible 
          ? 'opacity-100 translate-y-0 pointer-events-auto' 
          : 'opacity-0 translate-y-4 pointer-events-none'
        }
        hover:bg-zinc-800
        group
      `}
      aria-label="Back to top"
      data-testid="back-to-top-btn"
    >
      <ChevronUp className="w-4 h-4 transition-transform group-hover:-translate-y-0.5" />
      <span className="font-mono text-[10px] tracking-wide">TOP</span>
    </button>
  );
}
